import React, { useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import slugify from "react-slugify";
import { LanguageContext } from "../context/LanguageContext";
import translations from "../data/langData";
import ReactSlider from "react-slider";
import axios from "axios";
import { ApiLinkContext } from "../context/ApiLinkContext";

import ReactPaginate from "react-paginate";

const JobPostings = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const { cv, cvCategory } = useContext(ApiLinkContext);

  const [value, setValue] = useState([0, 10000]);
  const [isRejimi, setIsRejimi] = useState(false);
  const [educationOpen, setEducationOpen] = useState(true);
  const [workExperience, setWorkExperience] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [gender, setGender] = useState("");

  const [tehsil, setTehsil] = useState({
    0: false, // Ali
    1: false, // Natamam
    2: false, // Orta
  });

  const [rejim, setRejim] = useState({
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
    10: false,
  });

  const [experience, setExperience] = useState({
    11: false,
    12: false,
    13: false,
    14: false,
  });

  const [category, setCategory] = useState("all");

  const handleTehsilChange = (e) => {
    const { id, checked } = e.target;
    setTehsil((prevTehsil) => ({
      ...prevTehsil,
      [id]: checked,
    }));
  };

  const handleRejimChange = (e) => {
    const { id, checked } = e.target;
    setRejim((prevRejim) => ({
      ...prevRejim,
      [id]: checked,
    }));
  };

  const handleExperienceChange = (e) => {
    const { id, checked } = e.target;
    setExperience((prevRejim) => ({
      ...prevRejim,
      [id]: checked,
    }));
  };

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  const [jwtToken] = useState(localStorage.getItem("jwt") || "");

  const filteredData = cv
    .filter((item) => {
      const priceFilter =
        item.emekhaqqi >= value[0] && item.emekhaqqi <= value[1];

      const educationFilter =
        (tehsil[0] && item.tehsil === "0") ||
        (tehsil[1] && item.tehsil === "1") ||
        (tehsil[2] && item.tehsil === "2") ||
        (!tehsil[0] && !tehsil[1] && !tehsil[2]);

      const rejimFilter =
        (rejim[5] && item.rejim === "0") ||
        (rejim[6] && item.rejim === "1") ||
        (rejim[7] && item.rejim === "2") ||
        (rejim[8] && item.rejim === "3") ||
        (rejim[9] && item.rejim === "4") ||
        (rejim[10] && item.rejim === "5") ||
        (!rejim[5] &&
          !rejim[6] &&
          !rejim[7] &&
          !rejim[8] &&
          !rejim[9] &&
          !rejim[10]);

      const categoryFilter = category === "all" || category === item.kateqoriya;

      const searchFilter =
        search === "" ||
        item.vezife.toLowerCase().includes(search.toLowerCase());

      const genderFilter = gender === "" || item.cins === gender;

      const workExperienceFilter =
        (experience[11] && item.isht === "0") ||
        (experience[12] && item.isht === "1") ||
        (experience[13] && item.isht === "2") ||
        (experience[14] && item.isht === "3") ||
        (!experience[11] &&
          !experience[12] &&
          !experience[13] &&
          !experience[14]);

      return (
        priceFilter &&
        educationFilter &&
        rejimFilter &&
        categoryFilter &&
        searchFilter &&
        genderFilter &&
        workExperienceFilter  
      );
    })
    .sort((a, b) => {
      switch (sortBy) {
        case "name-asc":
          return a.ad.localeCompare(b.ad);
        case "name-desc":
          return b.ad.localeCompare(a.ad);
        case "position-asc":
          return a.vezife.localeCompare(b.vezife);
        case "position-desc":
          return b.vezife.localeCompare(a.vezife);
        case "salary-asc":
          return a.emekhaqqi - b.emekhaqqi;
        case "salary-desc":
          return b.emekhaqqi - a.emekhaqqi;
        default:
          return 0;
      }
    });

  useEffect(() => {
    const handleStorageChange = (event) => {
      // Burada lokal yaddaşda dəyişiklik olub-olmaması yoxlanılır
      if (event.key === "jwt") {
        console.log("JWT dəyişdi, istifadəçi çıxış etdi");
        // Lazım gələrsə, əlavə əməliyyatları buraya əlavə edə bilərsən
      }
    };

    // Hadisəni dinləyirik
    window.addEventListener("storage", handleStorageChange);

    // Cleanup funksiyası ilə dinləməyi dayandırırıq
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const resetFilters = () => {
    setValue([0, 10000]); // Maaş aralığını sıfırlayırıq
    setIsRejimi(false); // Rejim filterini sıfırlayırıq
    setSearch(""); // Axtarış inputunu sıfırlayırıq
    setSortBy(""); // Sıralama seçimini sıfırlayırıq
    setTehsil({ 0: false, 1: false, 2: false }); // Təhsil filterlərini sıfırlayırıq
    setRejim({ 5: false, 6: false, 7: false, 8: false, 9: false, 10: false }); // Rejim filterlərini sıfırlayırıq
    setExperience({ 11: false, 12: false, 13: false, 14: false });
    setCategory("all"); // Kateqoriya filterini "all" olaraq sıfırlayırıq
    setGender("");
  };

  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10; // Sayfa başına element sayı

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
    window.scrollTo({ top: 500 });
  };

  // Paginated data slice
  const currentData = filteredData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );
  useEffect(() => {
    setCurrentPage(0); // Reset to the first page whenever filter changes
  }, [value, search, sortBy, gender, tehsil, rejim, category,experience]);

  return (
    <>
      <section className="jobpostings " style={{ background: "#FAFAFA" }}>
        <div className="container-fluid">
          <div className="row g-3 p-4 py-3 ">
            <div className="jobBread ">
              <h4 className="text-start">{t.insanresurs1}</h4>
              <p>
                {t.homePage} {`>`} {t.insanresurs} {`>`} {t.insanresurs1}
              </p>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
              <div className="filterBox my-3">
                <h3> {t.filter}</h3>
                <hr />
                <div className="filterInputs">
                  <div>
                    <h6>{t.gender}</h6>
                    <div className="d-flex justify-content-between align-items-center ">
                      <button
                        className="w-100"
                        style={{
                          borderTopLeftRadius: "10px",
                          borderBottomLeftRadius: "10px",
                          background: `${gender == "" ? "#4CAF50" : ""}`,
                          color: `${gender == "" ? "#fff" : ""}`,
                        }}
                        onClick={() => setGender("")}
                      >
                        {t.projectsall}
                      </button>
                      <button
                        className="w-100"
                        onClick={() => setGender("0")}
                        style={{
                          background: `${gender == "0" ? "#4CAF50" : ""}`,
                          color: `${gender == "0" ? "#fff" : ""}`,
                        }}
                      >
                        {t.man}
                      </button>
                      <button
                        className="w-100"
                        style={{
                          borderTopRightRadius: "10px",
                          borderBottomRightRadius: "10px",
                          background: `${gender == "1" ? "#4CAF50" : ""}`,
                          color: `${gender == "1" ? "#fff" : ""}`,
                        }}
                        onClick={() => setGender("1")}
                      >
                        {t.woman}
                      </button>
                    </div>
                  </div>

                  <div className="my-4">
                    <h6>{t.maasaraligi}</h6>
                    <div>
                      <div className="d-flex justify-content-between my-3">
                        <span>{value[0]} {t.maasdan} </span>
                        <span>{value[1]} {t.maasqeder} </span>
                      </div>
                      <ReactSlider
                        className="rangeslider"
                        value={value} // slider değeri state'den al
                        onChange={handleChange} // her değişiklikte handleChange çalışır
                        defaultValue={[value[0], value[1]]} // başlangıç değeri
                        pearling
                        minDistance={5}
                        min={0} // minimum değer
                        max={10000} // maksimum değer
                      />
                    </div>
                  </div>
                  <div className="my-4">
                    <h6>{t.selectcat}</h6>
                    <div>
                      <select
                        name=""
                        id=""
                        onChange={(e) => setCategory(e.target.value)}
                        className="w-100 p-3 my-2"
                        style={{
                          border: "1px solid rgb(244, 244, 244)",
                          borderRadius: "10px",
                        }}
                      >
                        <option value="all">{t.allCat}</option>
                        {cvCategory &&
                          cvCategory.map((item) => (
                            <option key={item} value={item.id}>
                              {language == "az"
                                ? item.name
                                : language == "en"
                                ? item.name_en
                                : language == "ru"
                                ? item.name_ru
                                : language == "tr"
                                ? item.name_tr
                                : language == "de"
                                ? item.name_de
                                : language == "pl"
                                ? item.name_pl
                                : ""}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="tehsilİnput">
                    <h6
                      className="d-flex justify-content-between"
                      onClick={() => setEducationOpen(!educationOpen)}
                    >
                      {t.education}
                      <i
                        className={`fa-solid fa-chevron-${
                          educationOpen ? "up" : "down"
                        }`}
                      ></i>
                    </h6>
                    <div className={`d-${educationOpen ? "block" : "none"}`}>
                      <input
                        type="checkbox"
                        id="0"
                        checked={tehsil[0]}
                        onChange={handleTehsilChange}
                      />
                      <label htmlFor="0">{t.ali}</label>
                      <br />
                      <input
                        type="checkbox"
                        id="1"
                        checked={tehsil[1]}
                        onChange={handleTehsilChange}
                      />
                      <label htmlFor="1">{t.natamam}</label>
                      <br />
                      <input
                        type="checkbox"
                        id="2"
                        checked={tehsil[2]}
                        onChange={handleTehsilChange}
                      />
                      <label htmlFor="2">{t.orta}</label>
                    </div>
                  </div>
                  <div className="isRejimi my-4">
                    <h6
                      className="d-flex justify-content-between"
                      onClick={() => setIsRejimi(!isRejimi)}
                    >
                      {t.isrejimi}
                      <i
                        className={`fa-solid fa-chevron-${
                          isRejimi ? "up" : "down"
                        }`}
                      ></i>
                    </h6>
                    <div className={`d-${isRejimi ? "block" : "none"}`}>
                      <input
                        type="checkbox"
                        id="5"
                        checked={rejim[5]}
                        onChange={handleRejimChange}
                      />
                      <label htmlFor="5">{t.tamstat}</label>
                      <br />
                      <input
                        type="checkbox"
                        id="6"
                        checked={rejim[6]}
                        onChange={handleRejimChange}
                      />
                      <label htmlFor="6">{t.yarim}</label>
                      <br />
                      <input
                        type="checkbox"
                        id="7"
                        checked={rejim[7]}
                        onChange={handleRejimChange}
                      />
                      <label htmlFor="7">{t.frilans}</label>
                      <br />
                      <input
                        type="checkbox"
                        id="8"
                        checked={rejim[8]}
                        onChange={handleRejimChange}
                      />
                      <label htmlFor="8">{t.tecrubeci}</label>
                      <br />
                      <input
                        type="checkbox"
                        id="9"
                        checked={rejim[9]}
                        onChange={handleRejimChange}
                      />
                      <label htmlFor="9">{t.uzaqdan}</label>
                      <br />
                      <input
                        type="checkbox"
                        id="10"
                        checked={rejim[10]}
                        onChange={handleRejimChange}
                      />
                      <label htmlFor="10">{t.muveqqeti}</label>
                    </div>
                  </div>
                  <div className="isRejimi my-4">
                    <h6
                      className="d-flex justify-content-between"
                      onClick={() => setWorkExperience(!workExperience)}
                    >
                      {t.istecrubesi}
                      <i
                        className={`fa-solid fa-chevron-${
                          workExperience ? "up" : "down"
                        }`}
                      ></i>
                    </h6>
                    <div className={`d-${workExperience ? "block" : "none"}`}>
                      <input
                        type="checkbox"
                        id="11"
                        checked={experience[11]}
                        onChange={handleExperienceChange}
                      />
                      <label htmlFor="11">{t.birildenaz}</label>
                      <br />
                      <input
                        type="checkbox"
                        id="12"
                        checked={experience[12]}
                        onChange={handleExperienceChange}
                      />
                      <label htmlFor="12">{t.birildenucileqeder}</label>
                      <br />
                      <input
                        type="checkbox"
                        id="13"
                        checked={experience[13]}
                        onChange={handleExperienceChange}
                      />
                      <label htmlFor="13">{t.ucilden5ileqeder}</label>
                      <br />
                      <input
                        type="checkbox"
                        id="14"
                        checked={experience[14]}
                        onChange={handleExperienceChange}
                      />
                      <label htmlFor="14">{t.besildencox}</label>
                    </div>
                  </div>
                  <div className="dilBilikleri my-4">
                    <h6
                      className="d-flex justify-content-between"
                      onClick={() => setLangOpen(!langOpen)}
                    >
                     {t.dilbilikleri}
                      <i
                        className={`fa-solid fa-chevron-${
                          langOpen ? "up" : "down"
                        }`}
                      ></i>
                    </h6>
                    <div className={`d-${langOpen ? "block" : "none"}`}>
                      <input type="checkbox" checked id="az" />
                      <label htmlFor="az">Azərbaycan dili</label>
                      <br />

                      <input type="checkbox" id="en" />
                      <label htmlFor="en">İngilis dili</label>
                      <br />

                      <input type="checkbox" id="ru" />
                      <label htmlFor="ru">Rus dili</label>
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-md-8 col-sm-12 col-12">
              <div className="allCv my-4">
                <h3>{t.butunnamizedler}</h3>
                <span style={{ opacity: "0.8" }}>
                  {filteredData.length > 0 ? filteredData.length : 0} {t.toplamnamized}
                </span>
              </div>
              <hr />
              <div className="allCvDetails">
                <div className="row justify-content-center">
                  <div className="col-6">
                    <input
                      type="text"
                      onChange={(e) => setSearch(e.target.value)}
                      value={search}
                      placeholder={t.searchnamized}
                    />
                  </div>
                  <div className="col-6">
                    <select
                      name=""
                      id="cvSelect"
                      value={sortBy}
                      onChange={(e) => setSortBy(e.target.value)}
                    >
                      <option value="" disabled selected>
                        {t.sirala}
                      </option>
                      <option value="name-asc">{t.nameasc}</option>
                      <option value="name-desc">{t.namedesc}</option>
                      <option value="position-asc">{t.positionasc}</option>
                      <option value="position-desc">{t.positiondesc}</option>
                      <option value="salary-asc">{t.salaryasc}</option>
                      <option value="salary-desc">{t.salarydesc}</option>
                    </select>

                    <div className="d-flex justify-content-end">
                      <button onClick={resetFilters}>
                        {t.clear} <i className="fa-solid fa-trash-can"></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-12  my-3">
                    <div className="row g-3">
                      {currentData.length == 0 ? (
                        <p className="text-center fs-5">
                          {t.searchnotfound}
                        </p>
                      ) : (
                        currentData.map((item) => {
                          return (
                            <>
                              <NavLink
                                to={`/jobdetails/${slugify(
                                  `${item.id}-${item.ad}-${item.soyad}-${item.vezife}`
                                ).toLowerCase()}`}
                                id="jobLink"
                              >
                                <div
                                  className="col-lg-2 col-md-2 col-sm-12 col-12"
                                  id="cvDetails"
                                  style={{
                                    borderTop: "2px solid #f3f3f3",
                                    borderLeft: "2px solid #f3f3f3",
                                    borderBottom: "2px solid #f3f3f3",
                                    borderTopLeftRadius: "8px",
                                    borderBottomLeftRadius: "8px",
                                    background: "#fff",
                                  }}
                                >
                                  <div className="profileImg">
                                    <img
                                      src="https://static.vecteezy.com/system/resources/previews/046/409/821/non_2x/avatar-profile-icon-in-flat-style-male-user-profile-illustration-on-isolated-background-man-profile-sign-business-concept-vector.jpg"
                                      alt=""
                                      className="img-fluid"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="col-lg-10 col-md-10 col-sm-12 col-12"
                                  id="cvDetails"
                                  style={{
                                    borderTop: "2px solid #f3f3f3",
                                    borderRight: "2px solid #f3f3f3",
                                    borderBottom: "2px solid #f3f3f3",
                                    borderTopRightRadius: "8px",
                                    borderBottomRightRadius: "8px",
                                    background: "#fff",
                                  }}
                                >
                                  <div className="d-flex justify-content-between">
                                    <div>
                                      <h5 className="mt-3">
                                        {item.vezife}
                                        <br />
                                        <span
                                          style={{
                                            opacity: "0.5",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {item.ad} {item.soyad} ({item.yash})
                                        </span>
                                      </h5>
                                    </div>
                                    <div className="d-flex">
                                      <span className="heartIcon mx-2">
                                        <i
                                          class="fa-solid fa-file-arrow-down"
                                          style={{ color: "#4CAF50" }}
                                        ></i>
                                      </span>
                                      <span className="heartIcon">
                                        <i class="fa-regular fa-heart"></i>
                                      </span>
                                    </div>
                                  </div>
                                  <br />
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                      <i
                                        class="fa-solid fa-money-bill"
                                        style={{ color: "#4CAF50" }}
                                      ></i>
                                      <span className="ms-1">
                                        {item.emekhaqqi} ₼
                                      </span>
                                      <div>
                                        <i
                                          class="fa-solid fa-location-dot ms-4"
                                          style={{ color: "#4CAF50" }}
                                        ></i>
                                        <span className="ms-1">
                                          {item.sheher}
                                        </span>
                                      </div>
                                    </div>

                                    <div>
                                      <span>
                                        {t.date}:{" "}
                                        {item.upload_date.split(" ")[0]}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </NavLink>
                            </>
                          );
                        })
                      )}
                    </div>
                    <div
                      className={`d-flex justify-content-center my-3 ${
                        currentData.length == 0 && "d-none"
                      }`}
                    >
                      <ReactPaginate
                        previousLabel={
                          <i className="fa-solid fa-chevron-left"></i>
                        }
                        nextLabel={
                          <i className="fa-solid fa-chevron-right"></i>
                        }
                        breakLabel={"..."}
                        pageCount={Math.ceil(
                          filteredData.length / itemsPerPage
                        )}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"react_pagination"}
                        activeClassName={"active"} // Aktiv səhifəyə "active" class-ı əlavə edilir
                        pageClassName={"page-item"} // Hər bir səhifə üçün class
                        previousClassName={"previous-page"} // Əvvəlki səhifə üçün class
                        nextClassName={"next-page"} // Növbəti səhifə üçün class
                        breakClassName={"break-page"} // "..." break üçün class
                        disabledClassName={"disabled"} // Aktiv olmayan səhifə üçün class
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default JobPostings;
